import React from 'react'
import RequestMoreInformation from '../RequestMoreInformation'

function ContactUsModal() {
    return (
        <>
            <div className='container mx-5'>
                {/* use this button to trigger this modal */}
                {/* <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#conatctUsModal">
                    Launch demo modal
                </button> */}


                <div className="modal fade" id="conatctUsModal" tabIndex="-1" role="dialog" aria-labelledby="conatctUsModalTitle" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title fw-bold" id="conatctUsModalTitle">Contact Us</h3>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body d-flex justify-content-center mb-3  bg-white">
                                <RequestMoreInformation />
                            </div>
                            {/* <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" className="btn btn-primary">Save changes</button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ContactUsModal